import { fabric } from 'fabric';
import { IGroupOptions, IRectOptions, ITextboxOptions, Object } from 'fabric/fabric-impl';

import Interactive from 'modules/overlay-canvas/canvases/interactive';
import { MyTextOptions } from 'modules/overlay-canvas/types';
import { commonPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import { DEFAULT_FONT_STACK } from 'shared/fonts';
import customization from '../customization';
import elements from '../elements';

export interface ConstructorProps {
  manager: Interactive;
}

export class BasePlaceholder {
  protected readonly manager: Interactive;
  protected readonly canvas: fabric.Canvas;

  constructor(props: ConstructorProps) {
    this.manager = props.manager;
    this.canvas = props.manager.canvas;
  }

  createTextPlaceholder(props: commonPlaceholder) {
    const { blockText, ...rest } = props;

    const { left, top } = elements.getLeftTop(this.canvas);
    const textbox = this.createTextbox({ text: blockText });
    return this.createGroup({
      objects: [textbox],
      data: rest,
      options: {
        left,
        top,
      },
    });
  }

  createImagePlaceholder(props: commonPlaceholder) {
    const { blockText, ...rest } = props;

    const { left, top } = elements.getLeftTop(this.canvas);

    const background = this.createRect();

    const center = background.getCenterPoint();
    const text = this.createText({
      text: blockText,
      options: {
        left: center.x,
        top: center.y,
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
      },
    });

    return this.createGroup({
      objects: [background, text],
      data: rest,
      options: {
        left,
        top,
      },
    });
  }

  protected createTextbox(props: { text: string; options?: ITextboxOptions }) {
    const { text, options = {} } = props;

    return new fabric.Textbox(text, {
      fontSize: 20,
      fontFamily: DEFAULT_FONT_STACK,
      fill: 'black',
      fontWeight: 'normal',
      textAlign: 'center',
      originX: 'center',
      originY: 'center',
      strokeWidth: 0,
      ...customization.getAllProperties(),
      ...options,
    });
  }

  protected createText(props: { text: string; options?: MyTextOptions }) {
    const { text, options = {} } = props;

    return new fabric.Text(text, {
      fontSize: 20,
      fontFamily: DEFAULT_FONT_STACK,
      fill: 'black',
      fontWeight: 'normal',
      textAlign: 'center',
      strokeWidth: 0,
      ...customization.getAllProperties(),
      ...options,
    });
  }

  protected createRect(props?: { options?: IRectOptions }) {
    const { options = {} } = props ?? {};

    return new fabric.Rect({
      width: 300,
      height: 100,
      strokeWidth: 0,
      fill: 'rgba(230, 230, 230, 0.6)',
      ...customization.getAllProperties(),
      ...options,
    });
  }

  protected createGroup(props?: { objects?: Object[]; data?: any; options?: IGroupOptions }) {
    const { objects = [], data, options = {} } = props ?? {};

    return new fabric.Group(objects, {
      backgroundColor: 'rgba(230, 230, 230, 0.6)',
      strokeWidth: 0,
      ...customization.getAllProperties(),
      data: {
        fontSize: 20,
        fontFamily: DEFAULT_FONT_STACK,
        color: '#000000',
        fontWeight: 'normal',
        textAlign: 'center',
        ...data,
      },
      ...options,
    });
  }
}
